import { focusFirstItemIn, focusLastItemIn } from './dropdownHelper.js';

/**
* Get lists of items
*
* @param {HTMLElement} currentItem
* @returns
*/
function getLists(currentItem) {
    const parentItem = currentItem.parentElement;
    const children = parentItem.parentElement.parentElement.children;

    if (children.length === 0) {
        return;
    }

    const lists = [];

    for (let i = 0; i < children.length; i++) {
        const child = children[i];

        if (child.nodeName.toLowerCase() === 'ul') {
            lists.push(child);
        }
    }

    return lists;
}

/**
* Focus first item in next list
*
* @param {HTMLElement} currentItem
*/
export function goToNextList(currentItem) {
    const lists = getLists(currentItem);

    if (lists.length <= 1) {
        focusFirstItemIn(lists[0]);
    }

    const parentItem = currentItem.parentElement;

    let nextSibling = parentItem.parentElement.nextElementSibling;

    if (nextSibling) {
        if (nextSibling.nodeName.toLowerCase() !== 'ul') {
            nextSibling = nextSibling.nextElementSibling;
        }

        focusFirstItemIn(nextSibling);
    } else {
        focusFirstItemIn(lists[0]);
    }
}

/**
* Focus last item in previous list
*
* @param {HTMLElement} currentItem
*/
export function goToPreviousList(currentItem) {
    const lists = getLists(currentItem);

    if (lists.length <= 1) {
        focusLastItemIn(lists[0]);
    } else {
        const parentItem = currentItem.parentElement;

        let previousSibling = parentItem.parentElement.previousElementSibling;

        if (previousSibling) {
            if (previousSibling.nodeName.toLowerCase() === 'h2') {
                previousSibling = previousSibling.previousElementSibling;
            }

            if (previousSibling.nodeName.toLowerCase() === 'ul') {
                focusLastItemIn(previousSibling);
            } else {
                focusLastItemIn(lists[lists.length - 1]);
            }
        } else {
            focusLastItemIn(lists[lists.length - 1]);
        }
    }
}

/**
 *
 *
 * @param {HTMLElement} currentItem
 * @returns {boolean}
 */
export function focusPreviousListItem(currentItem) {
    const parentItem = currentItem.parentElement;
    const previousItem = parentItem.previousElementSibling;

    if (previousItem) {
        // @ts-ignore
        previousItem.querySelector('.prom-dropdown__listitem').focus();

        return true;
    }

    return false;
}

/**
 *
 *
 * @param {HTMLElement} currentItem
 * @returns {boolean}
 */
export function focusNextListItem(currentItem) {
    const parentItem = currentItem.parentElement;
    const nextItem = parentItem.nextElementSibling;

    if (nextItem) {
        // @ts-ignore
        nextItem.querySelector('.prom-dropdown__listitem').focus();

        return true;
    }

    return false;
}
